import React from 'react'
import { useHistory } from 'react-router-dom'
import { IconListSearch, IconShieldCheck } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'
import { Drawer } from '@/components/drawer/Drawer'

import { AuditDrawerContent } from './AuditDrawerContent'

import './KodiAudit.scss'

const AUDIT_PARAM = 'audit_uuid'

// One instance per assistant turn; props are stable per message, so memoize to
// avoid re-renders on unrelated streaming churn.
export const KodiAuditButton = React.memo(({ auditUuid }) => {
  const history = useHistory()
  // Reopen on refresh: read the URL once at mount. useHistory (unlike
  // useLocation) doesn't subscribe to navigation, so this button itself doesn't
  // re-render on route changes — one instance per assistant turn, and opening a
  // drawer mutates the URL. (The Drawer subtree still reads useLocation and
  // re-renders on its own; this only keeps the per-turn buttons off that path.)
  const openFromUrl = new URLSearchParams(history.location.search).get(AUDIT_PARAM) === auditUuid

  const writeParam = (value) => {
    // Read the live search (Drawer's handleOpen/handleClose have already pushed
    // by now) so we edit the current entry rather than a stale one.
    const params = new URLSearchParams(history.location.search)
    if (value) params.set(AUDIT_PARAM, value)
    else params.delete(AUDIT_PARAM)
    history.replace({ search: params.toString() })
  }

  return (
    <Drawer
      expandable
      autoTrigger={openFromUrl}
      onClose={() => writeParam(null)}
      title={
        <span className="kodi-audit__title">
          <span className="kodi-audit__title-main">
            <IconShieldCheck size={17} /> Audit trail
          </span>
          <span className="kodi-audit__title-uuid">{auditUuid}</span>
        </span>
      }
      trigger={(handleOpen) => (
        <Button
          small
          square
          basic
          aria-label="View audit trail"
          onClick={() => {
            handleOpen()
            writeParam(auditUuid)
          }}
        >
          <IconListSearch />
        </Button>
      )}
    >
      <AuditDrawerContent auditUuid={auditUuid} />
    </Drawer>
  )
})

KodiAuditButton.displayName = 'KodiAuditButton'
